import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export default function LlcPeopleList({ llcData }) {
  const llcPeople = useMemo(() => {
    const people = [];
    if (llcData.agentName) people.push({ title: 'Agent', name: llcData.agentName, address: llcData.agentAddress });
    (llcData.officers || []).forEach(({ position, name }) => people.push({ title: position, name }));
    return people;
  }, [llcData.companyId]);

  if (llcPeople.length == 0) return null;

  return (
    <div className="d-flex flex-wrap align-items-stretch gap-1 py-1">
      {llcPeople.map((person, i) => (
        <div className="flex-grow-1" key={i} style={{ minWidth: '25%' }}>
          <div className="bg-light p-3 h-100">
            <div><strong>{person.name}</strong></div>
            <div><small>{person.title}</small></div>
            {person.address && <div><small>{person.address}</small></div>}
          </div>
        </div>
      ))}
    </div>
  );
}

LlcPeopleList.propTypes = {
  llcData: PropTypes.shape({
    agentAddress: PropTypes.string,
    agentName: PropTypes.string,
    officers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      position: PropTypes.string
    }))
  })
};
